module.exports = __webpack_public_path__ + "img/ufgas.ac5e485f.svg";